<template>
  <div>
    <b-row class="mx-md-0 p-md-3">
      <b-col cols="12" md="12">
        <b-row class="bg-white py-3">
          <b-col cols="12" md="12">
            <requiredComponent
              customClass="color_second font_18"
              slot="label"
              :label="$lang.ticketLang.text_message"
              :rules="$v.form.text.$params"
            />
            <Input
              label=""
              :value="form.text"
              name="text"
              id="text"
              type="textarea"
              minLength="3"
              :textareaRows="5"
              :requiredStar="true"
              :state="$v.form.text.$dirty ? !$v.form.text.$error : null"
              :vuelidateObj="$v.form.text"
              @input="input"
            />
          </b-col>
          <b-col cols="12" md="12" v-if="accessLevel === 'admin'">
            <b-form-group :label-cols="$config.form.labelCol">
              <requiredComponent
                customClass="color_second font_18"
                slot="label"
                :label="$lang.ticketLang.ticket_status"
                :rules="$v.form.ticket_status_selected.$params"
              />
              <selectFind
                :options="ticket_status_options"
                v-model="$v.form.ticket_status_selected.$model"
                label="text"
                id="value"
                :isValid="
                  $v.form.ticket_status_selected.$dirty
                    ? !$v.form.ticket_status_selected.$error
                    : null
                "
              />

              <b-form-invalid-feedback
                :style="{
                  display: $v.form.ticket_status_selected.$error
                    ? 'block'
                    : 'none',
                }"
                class="text-left"
              >
                <FeedbackMessages
                  :state="
                    $v.form.ticket_status_selected.$dirty
                      ? !$v.form.ticket_status_selected.$error
                      : null
                  "
                  :label="$lang.ticketLang.ticket_status"
                  :vuelidateObj="$v.form.ticket_status_selected"
                />
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="7"
            class="d-none d-md-flex align-items-end justify-content-start"
          >
            <Button
              v-if="accessLevel === 'user'"
              btnClass="font_18"
              variant="danger"
              :click="() => showConfirm()"
              :loading="loading"
              :title="$lang.ticketLang.end_ticket"
            />
          </b-col>
          <b-col cols="12" md="5">
            <SingleUpload
              :url="singleUploadUrl"
              :id="attachmentId"
              :attachmentTypeId="22"
              :acceptFormats="acceptFormats"
              attachmentTypeName="attachment_type_ticket"
              @hasFile="updateHasFile"
              @success="updateSuccessUploaded"
            />
            <Button :click="submit" :loading="loading" title="ارسال پیام" />
            <Confirm
              v-model="confirmData.show"
              :title="confirmData.title"
              :description="confirmData.description"
              :ok-title="$lang.ticketLang.yes"
              :cancel-title="$lang.ticketLang.no"
              :loading="confirmData.loading"
              :loadingSpinnerText="$lang.updating_data"
              dynamicClass=""
              @ok="changeState"
              @cancel="confirmData.show = false"
            />
          </b-col>
          <b-col cols="12" md="12" class="text-center d-md-none mt-3">
            <Button
              v-if="accessLevel === 'user'"
              btnClass="font_18"
              variant="danger"
              :click="() => showConfirm()"
              :loading="loading"
              :title="$lang.ticketLang.end_ticket"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Input from "@/components/global/Input";
import SingleUpload from "@/components/global/SingleUpload";
import Button from "@/components/global/Button";
import FeedbackMessages from "@/components/global/FeedbackMessages";
import Confirm from "@/components/base/confirm";
import { required, minLength, requiredIf } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { generateApiUrl, renderEumOptions } from "@/shared/utils";

export default {
  name: "send-message",
  inject: [
    "ticketAnswerRepository",
    "ticketDoneRepository",
    "ticketDetailsRepository",
  ],
  components: {
    Input,
    SingleUpload,
    Button,
    FeedbackMessages,
    Confirm,
  },
  validations: {
    form: {
      text: {
        minLength: minLength(3),
        required,
      },
      ticket_status_selected: {
        required: requiredIf((vm) => vm.accessLevel === "admin"),
      },
    },
  },
  props: {
    accessLevel: {
      type: String,
      default: null,
    },
    id: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      acceptFormats: [
        {
          caption: "عکس",
          value: "10MB",
          suffix: ["png", "jpg", "jpeg"],
        },
        {
          caption: "مجموعه آفیس",
          value: "20MB",
          suffix: ["pdf", "xls", "xlsx", "doc", "docx", "ppt", "pptx"],
        },
      ],
      form: {
        text: null,
        ticket_status_selected: null,
      },
      confirmData: {
        loading: false,
        show: false,
        title: this.$lang.ticketLang.end_ticket,
        description: `با خاتمه درخواست فقط درخواست قابل مشاهده خواهد بود و امکان اضافه کردن پیام به آن وجود نخواهد داشت ضمنا درخواست توسط پشتیبان‌ها بررسی نخواهد شد و باید برای پیگیری موضوع این درخواست یا موضوعات دیگر درخواست جدید زده شود.
          <br>
          لطفا فقط زمانی درخواست را خاتمه دهید که موضوع مطرح شده در آن به نتیجه رسیده باشد.
          <br>
          <strong>با توجه به در نظر گرفتن تمام نکات گفته شده از خاتمه درخواست مطمئن هستید؟</strong>
        `,
      },
      attachmentId: null,
      hasFile: false,
      successUploaded: false,
    };
  },
  computed: {
    singleUploadUrl() {
      return generateApiUrl(
        ["resources", "attachment"],
        ["ticket_detail", this.attachmentId]
      );
    },
    ticket_status_options() {
      return renderEumOptions("ticket_status");
    },
  },
  methods: {
    pathOr,
    generateApiUrl,
    input(key, value) {
      /* guidance: update key of form inputs */
      this.form[key] = value;
      // check validation and reset when value in null
      this.$v.form[key].$touch();
      !value && this.$v.form[key].$reset();
    },
    updateHasFile(value) {
      this.hasFile = value;
    },
    updateSuccessUploaded(value) {
      this.successUploaded = value;
      this.loading = false;
      if (value) {
        this.resetForm();
        this.$emit("getData");
      }
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$anyError || this.loading) return;

      try {
        this.loading = true;
        /* guidance: send ticket status id 1 for support pending status when access level is user */
        const payload = {
          description: this.form.text,
          ticket_status_id: pathOr(
            1,
            ["value"],
            this.form.ticket_status_selected
          ),
        };
        let response = null;
        if (this.accessLevel === "admin") {
          response = await this.ticketAnswerRepository.edit(this.id, payload);
        } else {
          response = await this.ticketDetailsRepository.partial_edit(
            this.id,
            payload
          );
        }
        const data = pathOr(null, ["data", "data"], response);
        this.attachmentId = pathOr(null, ["ticket_detail_code"], data);
        /* guidance: check if has not file set finish */
        if (!this.hasFile) {
          this.updateSuccessUploaded(true);
        }
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.updateSuccessUploaded(false);
      }
    },
    resetForm() {
      this.form.text = null;
      this.$v.$reset();
    },
    showConfirm() {
      this.confirmData.show = true;
    },
    async changeState() {
      if (this.accessLevel !== "user") return;
      try {
        this.confirmData.loading = true;
        const response = await this.ticketDoneRepository.partial_edit(this.id);
        this.$notify.success(response.data.message);
        this.$emit("getData");
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.confirmData.loading = true;
      }
    },
  },
};
</script>
